import { IABTest } from "./interfaces/abtest.interface";
import { IAnalyticsSystem } from "./interfaces/analytics-system.interface";
import { IAnalyticsBindEventData } from './interfaces/analytics-data.interface';
import { AnalyticsEvent } from "./enums/analytics-event.enum";
import { PostMessageEvent } from "../../enums/post-message-event.enum";
import { getEventName } from "./get-event-name";
import { IQuiz } from "../../interfaces/quiz.interface";

export interface IYaMetrikaOptions {
  enableWebvisor?: boolean;
}

declare global {
  interface Window {
    ym: any;
    dentolo_quiz_ec: any[];
  }
}

export class YaMetrikaCounter implements IAnalyticsSystem {
  constructor(
    private readonly metrika_number: number,
    private readonly bindEventsList?: IAnalyticsBindEventData[],
    private readonly prefix: string = "",
    private readonly options?: IYaMetrikaOptions
  ) { }

  private SRC = "https://mc.yandex.ru/metrika/tag.js";

  public init(quiz: IQuiz) {

    this.setupYMStub();

    const isAlreadyExist = document.querySelector(`[src="${this.SRC}"]`);

    if (!isAlreadyExist) {
      const script = document.createElement("script");
      const firstScript = document.getElementsByTagName("script")[0];
      script.async = true;
      script.src = this.SRC;
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }

    if (!window[`yaCounter${this.metrika_number}`]) {

      window.ym(this.metrika_number, "init", {
        trackLinks: true,
        clickmap: true,
        webvisor: this.options?.enableWebvisor,
        accurateTrackBounce: true,
        triggerEvent: true
      });
    } else {
      console.log(`counter yaCounter${this.metrika_number} already exist`);
    }

    if (this.options?.enableWebvisor) {
      quiz.sendDataToIframe(PostMessageEvent.ENABLE_WEBVISOR, {
        counter: this.metrika_number,
        domain: window.location.hostname
      });
    }
  }

  public setParams(params: Record<string, any>) {
    window.ym(this.metrika_number, "params", params);
  }

  public async track(event: AnalyticsEvent, params?: Record<string, any>) {
    const eventName = getEventName(event, params, this.bindEventsList, this.prefix);
    console.log("track event: ", eventName);
    console.log("counter: ", this.metrika_number);
    window.ym(this.metrika_number, "reachGoal", eventName, params);
  }

  public setABTest(abTest: IABTest) {
    window.ym(this.metrika_number, "params", {
      ABTest: {
        [abTest.test_name]: abTest.test_variant
      }
    })
  }

  setupYMStub() {
    const $this = this;

    if (!window.ym) {
      window.ym = function () {
        window.ym.a = window.ym.a || [];
        window.ym.a.push(arguments);
      };
      window.ym.l = new Date().getTime();
    } else {
      console.log("ya-metrika stub already exist");
    }
  }
}
